/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Stats_QuestionsInputs */

const en_course_stats_questions = /** @type {(inputs: Course_Stats_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const ja_course_stats_questions = /** @type {(inputs: Course_Stats_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題`)
};

const fr_course_stats_questions = /** @type {(inputs: Course_Stats_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const de_course_stats_questions = /** @type {(inputs: Course_Stats_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Course_Stats_QuestionsInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_stats_questions = /** @type {((inputs?: Course_Stats_QuestionsInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Stats_QuestionsInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_stats_questions(inputs)
	if (locale === "ja") return ja_course_stats_questions(inputs)
	if (locale === "fr") return fr_course_stats_questions(inputs)
	return de_course_stats_questions(inputs)
});